import Swiper from 'swiper/bundle'

export default function PriceSlider () {
  const SWIPER = new Swiper('.mtt-price-cards .swiper-container', {
    init: false,
    slidesPerView: 1.1,
    speed: 800,
    spaceBetween: 16,
    watchOverflow: true,
    breakpoints: {
      451: {
        slidesPerView: 1.2
      },
      651: {
        slidesPerView: 1.7
      },
      851: {
        slidesPerView: 2.1
      },
      1051: {
        slidesPerView: 2.5
      },
      1251: {
        slidesPerView: 3
      }
    }
  })

  if (document.querySelector('.mtt-price-cards .swiper-container')) SWIPER.init()
}
